import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppScope } from '@klickdata/core/resource';

@Component({
    selector: 'app-main-catalog-tests',
    templateUrl: './main-catalog-tests.component.html',
    styleUrls: ['./main-catalog-tests.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainCatalogTestsComponent implements OnInit {
    AppScope = AppScope;
    constructor() {}

    ngOnInit(): void {}
}
